import { accountRouteList } from "apps/Account/Routes";
import LayoutIndex from "apps/layout/LayoutIndex";
import { Route, Routes } from "react-router-dom";
import { landingRouteList } from "apps/Landing/Routes";
import { realStateRouteList } from "apps/RealState/Routes";
import { newsRouteList } from "apps/News/Routes";
import NotFound from "apps/Common/NotFound";
import { customerPanelRouteList } from "apps/CustomerPanel/Routes";
import AboutUsIndex from "apps/AboutUs/AboutUsIndex";
import ContactUsIndex from "apps/ContactUs/ContactUsIndex";
import FAQIndex from "apps/FAQ/FAQIndex";
import ProblemsSuggestionIndex from "apps/ProblemsSuggestion/ProblemsSuggestionIndex";
import ProtectionPersonalDataIndex from "apps/ProtectionPersonalData/ProtectionPersonalIndex";
import CookiPolicyAgreement from "apps/CookiePolicy/CookiePolicyIdex";
import MLSDescription from "apps/MLS/MLSDescription";
import IntroduceDopingIndex from "apps/Doping/Pages/IntroduceDopings/IntroduceDopingIndex";
import SalesTeam from "apps/SalesTeam/SalesTeam";
import MobileAppsIndex from "apps/MobileApps/MobileAppsIndex";
import WhyStore from "apps/Account/Pages/Institutional/Components/WhyStore";
import SecureShopping from "apps/SecureShopping/SecureShoppingIndex";
import EIDSIndex from "apps/Account/Pages/EIDS/EIDSIndex";
import SharedFavoriteListDetails from "apps/CustomerPanel/Favorite/Pages/SharedFavoriteListDetails/SharedFavoriteListDetails";
import SiteMapIndex from "apps/SiteMap.tsx/SiteMapIndex";
import PageItemDetailsIndex from "./PageItemDetails.tsx/PageItemDetailsIndex";
import ContractRuleAgreement from '../../src/apps/Account/Pages/Register/Components/ContractRuleAgreement';

export const RouteList = () => {
  return (
    <Routes>
      <Route element={<LayoutIndex  />}>
        {accountRouteList}
        {customerPanelRouteList}
        {landingRouteList}
        {realStateRouteList}

        <Route path="/eids" element={<EIDSIndex />} />
        <Route
          path="/favori/detay/:listId"
          element={<SharedFavoriteListDetails />}
        />
       

        
      </Route>
      <Route element={<LayoutIndex wrapperClassNames="!p-0" />}>
        {newsRouteList}
        <Route path="/hakkimizda" element={<AboutUsIndex />} />
        <Route path="/iletisim" element={<ContactUsIndex />} />
        <Route path="/ekibimiz" element={<SalesTeam />} />
        <Route path="/mobil/uygulamalar" element={<MobileAppsIndex />} />
        <Route path="/neden-magaza" element={<WhyStore />} />
        <Route path="/PPS-aciklama" element={<MLSDescription />} />
        <Route
          path="/:userType/doping/aciklama"
          element={<IntroduceDopingIndex />}
        />
        <Route
          path="/:userType/doping/aciklama"
          element={<IntroduceDopingIndex />}
        />
        <Route path="/sss" element={<FAQIndex />} />
        <Route path="/site-haritasi" element={<SiteMapIndex />} />
        <Route path="/guvenli-alisveris" element={<SecureShopping />} />
        <Route path="/sayfa/detay/:pageId" element={<PageItemDetailsIndex />} />
        <Route path="/cerezler" element={<CookiPolicyAgreement />} />
         <Route
          path="/sorunlar-oneriler"
          element={<ProblemsSuggestionIndex />}
        />
        <Route path="/sozlesme-kurallar" element={<ContractRuleAgreement />} />

        <Route
          path="/kisisel-verilerin-korunmasi"
          element={<ProtectionPersonalDataIndex />}
        />
        <Route
          path="*"
          element={
            <>
              <NotFound />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
